import { render, staticRenderFns } from "./proofOfPayment.vue?vue&type=template&id=0e82c8dc&"
import script from "./proofOfPayment.vue?vue&type=script&lang=js&"
export * from "./proofOfPayment.vue?vue&type=script&lang=js&"
import style0 from "./proofOfPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports